import type { Moment } from 'moment';

export const getCreativeDefaultTime = (valUtc: Moment, liDateUtc: Moment | null, field: string) => {
  const result = valUtc.clone();

  if (liDateUtc && valUtc.isSame(liDateUtc, 'day')) {
    result.hours(liDateUtc.hours()).minutes(liDateUtc.minutes()).seconds(liDateUtc.seconds());
  } else {
    field === 'startDate' ? result.startOf('day') : result.endOf('day');
  }

  return result.milliseconds(0);
};
